export default {
  content: `<p>
    中国の算力（コンピューティング能力）発展は、「スマートコンピューティングが主導し、全国一体化コンピューティングネットワークを中核とする」兆単位の産業構造を形成しています。 「東数西算」（東部のデータを西部のコンピューティングリソースで処理する）戦略に基づき、中国はコンピューティングと電力の深い連携を通じて、コンピューティングを「水道・電力」のように即時利用可能な公共インフラへと変革しつつあります。
</p>
<p>
    中国の算力発展は、「ハードウェアによるシェア拡大競争」から「全国統一運用とサービス」への深い転換という重要な岐路に立っています。 米国のハイテク大手（CapEx）による純粋な市場主導型モデルとは異なり、中国の算力は「政府によるトップダウン設計 + 市場のイノベーション活力」というユニークな二輪駆動の特徴を示しています。
</p>`,
  t1: `<p>
    <strong>スマートコンピューティング規模の爆発的成長：</strong>2026年3月末現在、中国のスマートコンピューティング規模は188.2万P（1882 EFLOPS相当）に達し、前年比2.5倍の飛躍的増加を達成し、スマートコンピューティングが絶対的な増分の主体となっています。
</p>
<p>
    <strong>「8+10+3」空間配置の形成：</strong>8大国家コンピューティングハブ、10国家データセンタークラスタ、3つのコンピューティング・電力協同発展区域を重点とする空間構造が完全に確立され、全国の算力リソースの集約的・規模的発展が実現しました。
</p>
<p>
    <strong>「20ミリ秒レイテンシー圏」の実現：</strong>ハブ間には145本の幹線光ケーブルが敷設され、全国各省から8大ハブまでのネットワーク伝送遅延はすべて20ミリ秒未満に低減され、「千里離れていても瞬時に到達」するコンピューティング・ネットワーク融合が現実のものとなりました。
</p>
<p>
    <strong>アプリケーションは「訓練」から「推論」へとシフトし、さらなる浸透を加速：</strong>大規模モデルの全面的な実用化に伴い、スマートコンピューティングセンターは大規模モデルの「訓練」主導から「推論」主導へと移行しつつあり、コンピューティングは工業、交通、行政など様々な産業に深く浸透しています。
</p>
<p>
    <strong>中核的な現実的課題：</strong>算力供給には構造的なミスマッチが存在し、西部の一部ノードは実体基盤の脆弱さから「建設されたが使われない、利用率が低い」という懸念に直面する一方、東部の高級・高信頼性コンピューティングは依然として逼迫しています。同時に、先端AIチップの自主イノベーションには依然として打開の余地があります。
</p>
<p>
    <br/>
</p>`,
  t2: `<p>
    <strong>世界最大の下流アプリケーションとトークン消費市場：</strong>中国は世界で最も密集した業界シーン、最大のAIアプリケーション展開市場、そして最速のトークン消費成長率を有しています。全国の1日あたりのAIトークン呼び出し量は140兆に急増し、2年前と比較して千倍以上の成長を遂げており、巨大な市場吸収力を提供しています。
</p>
<p>
    <strong>国家体制による「東数西算」とリソース調達能力：</strong>中国は世界に類を見ない「一枚岩」の調整優位性を持っています。「東数西算」の8大ハブと10大クラスタの配置を通じて、東部の高密度なコンピューティング需要を、西部の風力・太陽光発電によるグリーン電力が豊富な地域にうまく誘導し、米国が直面している「電力網麻痺」という局地的危機を効果的に回避しています。
</p>
<p>
    <strong>コスト削減と効率向上を実現する超高速インフラ製造能力：</strong>中国の整った電子機器製造産業チェーンに支えられ、国内クラウドベンダーはすでに全モジュール化データセンターアーキテクチャ（例：Alibaba Cloud CUBE 5.0）を実現し、大規模AIDCの納期を業界従来の1年から100日に劇的に短縮し、建設コストを10%削減しています。
</p>
<p>
    <br/>
</p>`,
  t3: `<p>
    <strong>構造的不均衡、「端で不足し、端で余る」というジレンマ：</strong>
</p>
<p>
    <strong>分子と分母のミスマッチ：</strong>総規模は大きいものの、国内のスマートコンピューティングセンターの平均有効利用率は30%未満にとどまっています。
</p>
<p>
    <strong>低端は過剰、高端は依然として不足：</strong>中低端で断片化されたコンピューティングは大量に遊休化している一方、安定して兆パラメータ級の超大規模モデルの事前学習を支えられる高品質・密結合・超低レイテンシーの高端コンピューティングは依然として著しく不足しています。
</p>
<p>
    <strong>エンドツーエンドの納品と地域間スケジューリングの技術的ボトルネック：</strong><br/>現在の全国コンピューティングネットワークは「リソースの可視化（モニタリング）」を達成しましたが、「タスクの実行可能性（納品）」はまだ完全には実現されていません。大規模モデルの訓練にはカード間の高帯域幅・密結合通信が厳格に要求され、西部に点在する遊休カードを物理的に直接接続して東部の中核的訓練タスクを処理することは困難であり、また地域間伝送コストも高く、データプライバシー・コンプライアンスの制約も多く存在します。
</p>
<p>
    <strong>国産ソフトウェア・ハードウェアエコシステム（CUDAの壁）という最大の難関：</strong><br/>華為昇騰や海光などのハードウェア性能は急速に進化していますが、NVIDIAのCUDAエコシステムは世界中の開発者に深く根付いています。国産コンピューティングは、下位ソフトウェアスタック、オペレーターライブラリの適合、そして大規模モデルの深層最適化において、巨大なエコシステム移行の壁に直面しており、「ハードウェアは作りやすくとも、エコシステムは築きにくい」という状況にあります。
</p>
<p>
    <br/>
</p>`,
  t4: `<p>
    <strong>「ハードウェア納品」から「トークンレンタルとサービス運用」へ</strong><br/>コンピューティングは、水道や電力のように即座に利用できる公共リソースへと変貌しつつあります。ベンダーは単にサーバーを販売するだけでなく、3大通信事業者やコンピューティングハードウェア大手は「トークンファクトリー」モデルや国家スーパーコンピューティングインターネットサービスへと全面的にシフトしています。
</p>
<p>
    <strong>AI異種コンピューティングプールの爆発的普及</strong><br/>異なるブランドやアーキテクチャのチップ間のハードウェアサイロを打破するため、国内では「AI異種コンピューティングプールプラットフォーム」の採用が加速しており、華為昇騰、海光DCU、Moor Threads、寒武紀など複数の国産チップを同一クラスタ内で混合配置し、シームレスな呼び出しを実現しています。
</p>
<p>
    <strong>産業チェーンの「逆成長」による不足部分の補完</strong><br/>外部からの地政学的圧力を受け、中国のコンピューティング産業は「初期のシステムインテグレーションから、後期に下層チップ、相互接続トポロジー、オペレーターライブラリ（DTK、FlagOSなど）を逆襲的に攻略する」という逆成長の自主化ルートを歩んでおり、全スタックの自主制御を加速しています。
</p>
<p>
    <br/>
</p>`,
};
